import type { ComponentPropsOptions, ExtractPublicPropTypes } from "vue";
import type { Size } from "@/components/helpers/common-props";
import { defineComponent } from "vue";
import { useCtx } from "@/composables/context";
import { p } from "@/utils/props-builder";

const formProps = {
  size: p.string<Size>("md"),
} satisfies ComponentPropsOptions;

export type FormProps = ExtractPublicPropTypes<typeof formProps>;

export const formCtx = useCtx<FormProps>();

export default defineComponent({
  name: "Form",
  emits: ["submit"],
  props: formProps,
  setup(props, { slots, emit }) {
    formCtx.provide(props);
    return () => (
      <form
        onSubmit={(e) => {
          e.preventDefault();
          emit("submit", e);
        }}
      >
        {slots.default?.()}
      </form>
    );
  },
});
